import { SharedFileRequest } from "@wingspanhq/wingspan-api-sdk";

import { ContextItem, RequirementTableItemData } from "../../../../types";

export const getSharedFileRequirementTitle = (
  requirement: RequirementTableItemData,
  context: ContextItem,
  sharedFileRequest: SharedFileRequest | undefined
): string => {
  if (requirement.name) {
    return requirement.name;
  }

  if (!requirement.dataSourceId) {
    return "File not uploaded";
  }

  return sharedFileRequest?.title || "--";
};
